export type SchemaVersion = 1;

export type MealType = 'lunch' | 'dinner' | 'breakfast' | 'snack';

export type RecipeCategory =
  | 'sandwich' | 'pinwheel' | 'quesadilla' | 'bento'
  | 'thermos' | 'pasta' | 'rice-grain' | 'mini-muffin'
  | 'breakfast-for-lunch' | 'dippable' | 'hidden-veggie';

export type Cuisine =
  | 'vietnamese' | 'chinese' | 'korean' | 'japanese' | 'thai'
  | 'american' | 'other';

export type GrocerySection =
  | 'produce' | 'dairy' | 'bakery' | 'meat' | 'pantry' | 'frozen' | 'other';

export type Rating = 'up' | 'meh' | 'down';
export type Status = 'yes' | 'maybe' | 'no';

export type Components = {
  protein: boolean; grain: boolean; veggie: boolean;
  fruit: boolean; fat: boolean;
};

export type Ingredient = {
  name: string;
  quantity: string;
  grocery_section: GrocerySection;
};

export type Recipe = {
  id: string;
  name: string;
  category: RecipeCategory | null;
  cuisine: Cuisine | null;
  description: string;
  meal_types: MealType[];
  components: Components;
  hidden_veggie: boolean;
  is_make_ahead: boolean;
  prep_minutes: number;
  cook_minutes: number | null;
  servings: number | null;
  safety_notes: string[];
  instructions: string[];
  ingredients: Ingredient[];
  image_url: string | null;
  image_focus: string | null;
  source_url: string | null;
  source_name: string | null;
  is_seed: boolean;
  archived: boolean;
  status: Status | null;
  notes: string;
  created_at: string;
  updated_at: string;
};

export type WeekMeal = {
  date: string;
  meal_type: MealType;
  recipe_id: string | null;
  rating: Rating | null;
  rated_at: string | null;
  note: string;
};

export type ShoppingItem = {
  id: string;
  name: string;
  quantity_hint: string;
  grocery_section: GrocerySection;
  used_in_recipes: string[];
  safety_modification: string | null;
  bulk_candidate: boolean;
  checked: boolean;
  checked_at: string | null;
  added_manually: boolean;
};

export type Week = {
  id: string;
  start_date: string;
  meals: WeekMeal[];
  shopping_list: ShoppingItem[];
  shopping_list_generated_at: string | null;
  exported_at: string | null;
};

export type SmartSuggestThresholds = {
  liked_recent_days: number;
  variety_days: number;
  overlap_min: number;
  component_coverage_min: number;
};

export type Settings = {
  family_name?: string;
  meal_types_enabled: MealType[];
  show_balance_check: boolean;
  show_picky_eater_nudge: boolean;
  show_safety_notes: boolean;
  smart_suggest_thresholds: SmartSuggestThresholds;
};

export type AppState = {
  schema_version: SchemaVersion;
  family_slug: string;
  updated_at: string;
  recipes: Recipe[];
  weeks: Week[];
  settings: Settings;
};

export const DEFAULT_THRESHOLDS: SmartSuggestThresholds = {
  liked_recent_days: 30,
  variety_days: 21,
  overlap_min: 0.4,
  component_coverage_min: 0.4,
};

export const DEFAULT_SETTINGS: Settings = {
  meal_types_enabled: ['lunch', 'dinner'],
  show_balance_check: true,
  show_picky_eater_nudge: true,
  show_safety_notes: true,
  smart_suggest_thresholds: DEFAULT_THRESHOLDS,
};
